module.exports = __webpack_public_path__ + "media/images/products/products/f3-6bd86f6b6bb177c57ade2946bd7a6939.jpg";